module.exports = __webpack_public_path__ + "img/pay-icon-8.4b71a011.png";